import axiosInstance from "@/plugins/axios.js";

export const login = async (email,password) => {
  try {
    //Encoder en plus du https (useless I know)
    var encodedEmail = btoa(email);
    var encodedPassword = btoa(password);

    const response = await axiosInstance.post(
      "/auth/login",
      { 
        email: encodedEmail, 
        password: encodedPassword 
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const register = async (email, password, consent) => {
  try {
    //Encoder en plus du https (useless I know)
    var encodedEmail = btoa(email);
    var encodedPassword = btoa(password);

    const response = await axiosInstance.post(
      "/auth/register",
      { 
        Email:encodedEmail,
        Password:encodedPassword,
        Consent: consent
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;

  } catch (error) {
    throw error;
  }
};

export const updateEmail = async (email, password, consent) => {
  try {
    //Encoder en plus du https (useless I know)
    var encodedEmail = btoa(email);

    await axiosInstance.post(
      "/auth/update-email",
      { 
        NewEmail:encodedEmail
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return true;

  } catch (error) {
    throw error;
  }
};

export const updatePassword = async (email, oldPassword, newPassword) => {
  try {
    //Encoder en plus du https (useless I know)
    var encodedEmail = btoa(email);
    var encodedOldPassword = btoa(oldPassword);
    var encodedNewPassword = btoa(newPassword);

    await axiosInstance.post(
      "/auth/update-password",
      { 
        Email:encodedEmail,
        CurrentPassword: encodedOldPassword,
        NewPassword: encodedNewPassword
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return true;

  } catch (error) {
    throw error;
  }
};

export const checkAuth = async () => {
  try {
    await axiosInstance.post("/auth/me");
    return true;
  } catch {
    return false;
  }
};

export const logout = async () => {
  try {
    await axiosInstance.post("/auth/logout");
    return true;
  } catch {
    return false;
  }
};

export const deleteAccount = async () => {
  try {
    await axiosInstance.delete("/UserStock");
    return true;
  } catch {
    return false;
  }
};